/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:1200px){.search-container[_ngcontent-%COMP%]   .results[_ngcontent-%COMP%]   .result[_ngcontent-%COMP%]{overflow-x:initial}}"];
export { styles as styles };
